<template>
	<div class="omapi-card__flex omapi-dash__upsell">
		<common-card class="omapi-dash__upsell">
			<div class="upsell__subtitle">Upgrade to {{ upsellPlan }}</div>
			<div class="upsell__title">Get more features in OptinMonster {{ upsellPlan }}:</div>
			<div class="upsell__features">
				<div v-for="feature in features" :key="feature" class="upsell__feature">
					<svg-checkmark-green-circle class="upsell__feature-icon" />
					<span class="upsell__feature-text">{{ feature }}</span>
				</div>
			</div>
			<div class="omapi-multi-column__buttons">
				<core-upgrade-button
					utm-medium="DashboardUpsellWidgetUpgrade"
					target="_blank"
					type="secondary"
					size="small"
					color="green"
				>
					Upgrade to {{ upsellPlan }}
				</core-upgrade-button>
				<core-upgrade-button
					utm-medium="DashboardUpsellWidgetAllFeatures"
					target="_blank"
					type="secondary"
					size="small"
				>
					See all features
				</core-upgrade-button>
			</div>
		</common-card>
	</div>
</template>

<script>
export default {
	props: {
		upsellPlan: {
			type: String,
			default: 'Growth',
		},
	},
	data() {
		return {
			proFeatures: [
				'Exit-Intent',
				'Campaign Scheduling',
				'Countdown Timers',
				'Device Targeting',
				'Yes/No Campaigns',
				'Click to Load',
				'2 Sub-Accounts',
				'Mobile Optimized Templates',
				'UTM and Cookie Targeting',
				'up to 25,000 pageviews',
				'Smart Tags',
				'2 additional sites',
			],
			growthFeatures: [
				'Coupon Wheel',
				'Geolocation',
				'WooCommerce Integration',
				'Adblock Detection',
				'Shopify Integration',
				'Custom Branding',
				'New Vs Returning',
				'Unlimited Sub-Accounts',
				'Onsite Follow Up Campaigns',
				'up to 100,000 pageviews',
				'Smart Tags',
				'4 additional sites',
			],
		};
	},
	computed: {
		features() {
			return 'Growth' === this.upsellPlan ? this.growthFeatures : this.proFeatures;
		},
	},
};
</script>
